"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.options = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var options = {};
exports.options = options;
var sizeMap = {
  small: 32,
  medium: 40,
  large: 48,
  xLarge: 64
};

var factory = function factory(_ref) {
  var identifier = _ref.identifier,
      UIBox = _ref.UIBox,
      Box = _ref.Box;

  var Header = /*#__PURE__*/function (_React$Component) {
    _inherits(Header, _React$Component);

    var _super = _createSuper(Header);

    function Header() {
      _classCallCheck(this, Header);

      return _super.apply(this, arguments);
    }

    _createClass(Header, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            theme = _this$props.theme,
            _this$props$box = _this$props.box,
            box = _this$props$box === void 0 ? {} : _this$props$box,
            onClick = _this$props.onClick,
            className = _this$props.className;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: this.headerWrapperClass
        }, /*#__PURE__*/_react["default"].createElement(Box, {
          theme: theme,
          className: className,
          bgColor: box.bgColor,
          top: "medium",
          left: "medium",
          bottom: "medium",
          right: "medium"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: this.headerLogoWrapperClass,
          onClick: onClick
        }, /*#__PURE__*/_react["default"].createElement("img", {
          className: this.headerLogoClass,
          src: this.optimizedImageSrc,
          alt: "header logo"
        }))));
      }
    }, {
      key: "devicePixelRatio",
      get: function get() {
        return 2;
      }
    }, {
      key: "headerLogoWrapperClass",
      get: function get() {
        var _cn;

        var _this$props2 = this.props,
            theme = _this$props2.theme,
            alignment = _this$props2.alignment;
        return (0, _classnames["default"])(theme.headerLogoWrapper, (_cn = {}, _defineProperty(_cn, theme.logoLeft, alignment === 'left'), _defineProperty(_cn, theme.logoCenter, alignment === 'center'), _defineProperty(_cn, theme.logoRight, alignment === 'right'), _cn));
      }
    }, {
      key: "headerLogoClass",
      get: function get() {
        var _cn2;

        var _this$props3 = this.props,
            theme = _this$props3.theme,
            size = _this$props3.size;
        return (0, _classnames["default"])(theme.headerLogo, (_cn2 = {}, _defineProperty(_cn2, theme.logoSmall, size === 'small'), _defineProperty(_cn2, theme.logoMedium, size === 'medium'), _defineProperty(_cn2, theme.logoLarge, size === 'large'), _defineProperty(_cn2, theme.logoXLarge, size === 'xLarge'), _cn2));
      }
    }, {
      key: "optimizedImageSrc",
      get: function get() {
        var _this$props4 = this.props,
            src = _this$props4.src,
            size = _this$props4.size;
        var newImageUrl = src.split('?')[0];
        return "".concat(newImageUrl, "?h=").concat(sizeMap[size], "&dpr=").concat(this.devicePixelRatio, "&q=75&auto=format,compress");
      }
    }, {
      key: "headerWrapperClass",
      get: function get() {
        var _this$props5 = this.props,
            theme = _this$props5.theme,
            preventDesktopBehaviour = _this$props5.preventDesktopBehaviour;
        return (0, _classnames["default"])(theme.headerWrapper, _defineProperty({}, theme.preventDesktop, preventDesktopBehaviour));
      }
    }]);

    return Header;
  }(_react["default"].Component);

  var options = {
    alignment: ['left', 'right', 'center'],
    size: ['small', 'medium', 'large', 'xLarge']
  };
  Header.displayName = identifier;
  Header.propTypes = {
    src: _propTypes["default"].string,
    box: _propTypes["default"].shape({
      bgColor: Box.propTypes.bgColor,
      horizontal: Box.propTypes.horizontal,
      vertical: Box.propTypes.vertical
    }),
    alignment: _propTypes["default"].oneOf(options.alignment),
    size: _propTypes["default"].oneOf(options.size),
    onClick: _propTypes["default"].func,
    theme: _propTypes["default"].shape(_objectSpread(_objectSpread({}, UIBox.themeShape), {}, {
      logoLeft: _propTypes["default"].string,
      logoCenter: _propTypes["default"].string,
      logoRight: _propTypes["default"].string,
      logoSmall: _propTypes["default"].string,
      logoMedium: _propTypes["default"].string,
      logoLarge: _propTypes["default"].string,
      logoXLarge: _propTypes["default"].string,
      headerWrapper: _propTypes["default"].string,
      preventDesktop: _propTypes["default"].string
    })),
    className: _propTypes["default"].string,
    preventDesktopBehaviour: _propTypes["default"].bool
  };
  Header.defaultProps = {
    preventDesktopBehaviour: false,
    alignment: 'left',
    size: 'small'
  };
  return Header;
};

var _default = factory;
exports["default"] = _default;